import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    submitted: false,
    isLoading: false,
    disabled: false,

    blockInputFields: false,

    importLoading: false,
    imported: false,

    updateLoading: false,
    deletionLoading: false,

    configuration: null,
    editConfiguration: null,
    configurations: null,

    advancedSettingsModal: false,

    addIntegrationModal: false,
    addIntegrationMessage: "",

    configurationToDelete: null,
    deleteConfigurationModal: false,

    unsavedChanges: false,

    blockActions: false,

    dataFileToImport: null,
    importData: null,
    deleteModal: false,

    successMessages: null,
    importErrorMessage: null,
    uploadInfoMessage: null,
    errorMessage: null,
    infoMessage: null,

    tooltips: {
        sales: false,
        debitor: false,
        importInstructions: false,
    },
};

const shopwareSlice = createSlice({
    name: "shopware",
    initialState,
    reducers: {
        toggleNewIntegration(state) {
            state.addIntegrationModal = !state.addIntegrationModal;
        },
        toggleDeleteIntegration(state, action) {
            state.configurationToDelete = action.payload;
            state.deleteModal = !state.deleteModal;
        },
        toggleAdvancedSettingsModal(state) {
            state.advancedSettingsModal = !state.advancedSettingsModal;
        },

        setEditConfiguration(state, action) {
            state.editConfiguration = action.payload;
        },
        setUnsavedChanges(state, action) {
            state.unsavedChanges = action.payload;
        },

        setUploadedDataFile(state, action) {
            state.dataFileToImport = action.payload;
        },

        addNewIntegrationRequest(state) {
            state.submitted = true;
            state.isLoading = true;
            state.errorMessage = null;
        },
        addNewIntegrationSuccess(state, action) {
            let config = action.payload;
            let configs = state.configurations;
            if (configs.length > 0) {
                configs = configs.concat(config);
                configs.sort((a, b) =>
                    a.clientName.toLowerCase() > b.clientName.toLowerCase()
                        ? 1
                        : a.clientName.toLowerCase() < b.clientName.toLowerCase()
                        ? -1
                        : 0
                );
            } else {
                configs = [config];
            }
            state.submitted = false;
            state.isLoading = false;
            state.addIntegrationModal = false;
            state.configurations = configs;
        },
        addNewIntegrationFailure(state, action) {
            state.submitted = false;
            state.isLoading = false;
            state.errorMessage = action.payload;
        },

        getConfigurationsForSelectedOrganizationRequest(state) {
            state.isLoading = true;
            state.configurations = null;
            state.infoMessage = null;
        },
        getConfigurationsForSelectedOrganizationSuccess(state, action) {
            state.isLoading = false;
            state.configurations = action.payload;
            state.errorMessage = null;
        },
        getConfigurationsForSelectedOrganizationFailure(state, action) {
            state.isLoading = false;
            state.configurations = null;
            state.errorMessage = action.payload;
        },

        getConfigurationRequest(state) {
            state.isLoading = true;
            state.configuration = null;
            state.errorMessage = null;
            state.importData = null;
            state.infoMessage = null;
        },
        getConfigurationsSuccess(state, action) {
            state.isLoading = false;
            state.configuration = action.payload;
            state.errorMessage = null;
            state.unsavedChanges = false;
        },
        getConfigurationFailure(state, action) {
            state.isLoading = false;
            state.configuration = null;
            state.errorMessage = action.payload;
        },
        updateConfigurationRequest(state) {
            state.isLoading = true;
            state.configuration = null;
            state.errorMessage = null;
        },
        updateConfigurationFailure(state, action) {
            state.isLoading = false;
            state.configuration = null;
            state.errorMessage = action.payload;
        },

        deleteConfigurationRequest(state) {
            state.deletionLoading = true;
            state.deletionErrorMessage = null;
        },
        deleteConfigurationSuccess(state, action) {
            if (state.configurations.length === 1) {
                state.configurations = [];
            } else if (state.configurations.length > 1) {
                const configIndex = state.configurations.findIndex(
                    (configuration) => configuration.externalUUID === action.payload
                );
                state.configurations = state.configurations.splice(configIndex, 1);
            }
            state.configurationToDelete = null;
            state.deleteModal = false;
            state.deletionLoading = false;
        },
        deleteConfigurationFailure(state, action) {
            state.deletionLoading = false;
            state.deletionErrorMessage = action.errorMessage;
        },

        shopwareStartAsyncImportRequest(state) {
            state.importLoading = true;
            state.errorMessage = null;
        },
        shopwareStartAsyncImportSuccess(state, action) {
            state.importLoading = false;
            state.successMessages = action.payload;
            state.dataFileToImport = null;
            state.importData = null;
            state.errorMessage = null;
        },
        shopwareStartAsyncImportFailure(state, action) {
            state.importLoading = false;
            state.dataFileToImport = null;
            state.errorMessage = action.payload;
        },

        shopwareStartImportAndValidateRequest(state) {
            state.importLoading = true;
            state.importData = null;
            state.errorMessage = null;
        },
        shopwareStartImportAndValidateSuccess(state, action) {
            state.importLoading = false;
            state.importData = action.payload;
            state.errorMessage = null;
        },
        shopwareStartImportAndValidateFailure(state, action) {
            state.importLoading = false;
            state.dataFileToImport = null;
            state.errorMessage = action.payload;
            state.importData = null;
        },

        setSubmitted(state, action) {
            state.submitted = action.payload;
        },
        toggleTooltips(state, action) {
            state.tooltips[action.payload] = !state.tooltips[action.payload];
        },
    },
});

export default shopwareSlice;
